import { AccessControlProvider } from "@pankod/refine-core";
import { authProvider } from "authProvider";
import memoizee from "memoizee"

const getUserIdentity = memoizee(async function () {
    return (await authProvider.getUserIdentity!!()!!)
}, { promise: true });
setInterval(() => {
    getUserIdentity.clear()
}, 6000)
export const acProvider: AccessControlProvider = {
    can: async ({ resource, action, params }) => {
        let user = await getUserIdentity()
        
        var ctReports = ["ctActivity", "lessonReportCT", "studentReportCT", "classReportCT"].map(itm => itm.toLowerCase())
        var flReports = ["lessonReport", "studentReport", "flActivity", "classReport"].map(itm => itm.toLowerCase())
        const chReport = [
            "classReport/aggregate", "chreport", "lessonreport", "assignable", "assignablereport"
        ]

        // Contact is accessible to everyone
        if (resource === "contact") {
            return Promise.resolve({ can: true });
        }

        if (resource?.toLowerCase() === "schoolreport") {
            if (user?.userType === "principal" || user?.userType === "teacher" || user?.userType === "admin") {
                return Promise.resolve({ can: true });
            } else {
                return Promise.resolve({ can: false });
            }
        }
        if (resource?.toLowerCase() === "teacherreport") {
            if (user?.userType === "principal" || user?.userType === "admin") {
                return Promise.resolve({ can: true });
            } else {
                return Promise.resolve({ can: false });
            }
        }

        if ((resource?.toLowerCase() === "gradelevelreport" || 
             resource?.toLowerCase() === "dyslexiareport") && 
            (user?.userType === "principal" || user?.userType === "teacher")) {
            return Promise.resolve({ can: true });
        }

        if (resource?.toLowerCase() === "libraryreport" || resource?.toLowerCase() === "classsummaryreport") {
            if (user?.userType === "teacher" || user?.userType === "principal" || user?.userType === "admin") {
                return Promise.resolve({ can: true });
            }
        }

        if (user?.userType === "parent") {
            return Promise.resolve({ can: parentAc(resource) });
        }

        if ((resource === "teachergroup" || resource === "group" || resource === "teacherGroup/subgroups" || resource === "teachergroup/subgroups") && user?.userType === "admin") {
            return Promise.resolve({ can: false });
        }
        if (resource === "report" && user?.userType !== "parent") {
            return Promise.resolve({ can: false });
        }

        if (user.userType === "admin") {
            return Promise.resolve({ can: true });
        }
        
        if ((resource === "dashboard") || (resource === "lesson") || (resource === "report") || (resource.toLowerCase() === "fluencyreport") || (resource.toLowerCase() === "criticalreport") || (resource === "checkpoint-report") || (chReport.indexOf(resource.toLowerCase()) !== -1) || (
            ctReports.indexOf(resource.toLowerCase()) !== -1
        ) || ((flReports.indexOf(resource.toLowerCase()) !== -1)) || (resource === "user" && (action === "edit"))
        ) {
            if (user.userType)
                return Promise.resolve({ can: true });
        }
        
        if (resource === "student") {
            if (user.userType === "admin" || user.userType === "principal" || user.userType === "teacher") {
                return Promise.resolve({ can: true });
            }
        }
        else if (user.userType === "principal") {
            if ((resource === "school") && (action === "show")) {
                return Promise.resolve({ can: true });
            } else if (resource === "principal" && (user.id === params?.id) && (action === "show")) {
                return Promise.resolve({ can: true });
            } else if (resource.toLowerCase() === "classreport/aggregate") {
                return Promise.resolve({ can: true });    
            } else if (resource === "teacher" || resource === "student") {
                return Promise.resolve({ can: true });
            } else if (resource?.toLowerCase() === "libraryreport" || resource?.toLowerCase() === "classsummaryreport") {
                return Promise.resolve({ can: true });
            }
        } else if (user.userType === "teacher") {
            if (resource === "teacher" && (user.id === params?.id) && (action === "show")) {
                return Promise.resolve({ can: true });
            } else if (resource?.toLowerCase() === "classreport/aggregate" || resource === "group" || (resource=== "teachergroup"&& (action === "create"|| action === "show"))||(resource=== "teacherGroup/subgroups"&& action === "create")) {
                return Promise.resolve({ can: true });
            } else if (resource?.toLowerCase() === "libraryreport" || resource?.toLowerCase() === "classsummaryreport") {
                return Promise.resolve({ can: true });
            } else if (resource?.toLowerCase() === "dyslexiareport") {
                return Promise.resolve({ can: true });
            } else {
                return Promise.resolve({ can: false, reason: "Unauthorized" });
            }
        }

        if (user.name === "reportSuperLevel") {
            return Promise.resolve({ can: true });
        } else {
            return Promise.resolve({ can: false, reason: "Unauthorized" });
        }

    }
};

function parentAc(pg: string) {
    const possible = ["children", "report", "dashboard", "studentreportct", "studentReportCT", "studentReport", "studentreport", "student", "user"]
    return possible.indexOf(pg) !== -1
}
